import { useLanguage } from '../../context/LanguageContext';
import { Sun, Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { id: 'home', label: t('nav.home') },
    { id: 'services', label: t('nav.services') },
    { id: 'portfolio', label: t('nav.portfolio') },
    { id: 'about', label: t('nav.about') },
    { id: 'contact', label: t('nav.contact') },
  ];

  return (
    <footer className="bg-stone-900 text-white py-16" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center">
                <Sun className="w-6 h-6 text-white" />
              </div>
              <span className="font-outfit font-bold text-xl">
                Abdou<span className="text-green-400">Business</span>
              </span>
            </div>
            <p className="text-stone-400 leading-relaxed max-w-md mb-6">
              {t('footer.description')}
            </p>
            <div className="flex gap-4">
              <a
                href="tel:+33123456789"
                className="w-10 h-10 bg-stone-800 rounded-lg flex items-center justify-center hover:bg-green-700 transition-colors"
                aria-label="Phone"
              >
                <Phone className="w-5 h-5" />
              </a>
              <a
                href="mailto:contact@abdoubusiness.fr"
                className="w-10 h-10 bg-stone-800 rounded-lg flex items-center justify-center hover:bg-green-700 transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
                className="w-10 h-10 bg-stone-800 rounded-lg flex items-center justify-center hover:bg-green-700 transition-colors"
                aria-label="Location"
              >
                <MapPin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-stone-400 hover:text-green-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-4">{t('footer.whyChooseUs')}</h3>
            <ul className="space-y-3">
              <li>
                <p className="text-stone-400 hover:text-green-400 transition-colors">
                  {t('footer.expertise')}
                </p>
              </li>
              <li>
                <p className="text-stone-400 hover:text-green-400 transition-colors">
                  {t('footer.freeQuote')}
                </p>
              </li>
              <li>
                <p href="#" className="text-stone-400 hover:text-green-400 transition-colors">
                  {t('footer.tailorMade')}
                </p>
              </li>
              <li>
                <p className="text-stone-400 hover:text-green-400 transition-colors">
                  {t('footer.support')}
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-sm">
            {t('footer.copyright')}
          </p>
          <p className="text-stone-500 text-sm">
            Made with <span className="text-green-400">♥</span> for a sustainable future
          </p>
        </div>
        <p className="mt-4 text-center text-xs text-muted-foreground opacity-75">
          SleepyReboot was here — built with care.
        </p>
      </div>
    </footer>
  );
};
